import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";


import { Checkbox, TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { createProcedure,getProcedureTypes} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";
import InputLabel from '@material-ui/core/InputLabel';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {format} from 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';


function CreateProcedure(props) {
  
  //console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;
const [statusColor, setStatusColor] = useState('alert-success');

const [procedureTypes,setProcedureTypes] =useState({procedureType:[]});

  React.useEffect(() => {
        const fetchProcedureTypes = async () => {
            try {
                
                const response = await getProcedureTypes()
                setProcedureTypes({procedureType: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchProcedureTypes();
    }, []);


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 
  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };






  return (

      <Formik
                  initialValues={{
                    procedureTypeName: "",
                    typeDescription: "",
                    
                   
                    
                  }}
                  validate={values => {
                    const errors = {};

                    
                    if (!values.procedureTypeName) {
                      errors.procedureTypeName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.typeDescription) {
                      errors.typeDescription = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    

                     

                    
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                    enableLoading();
                    
                    createProcedure(
                      values.procedureTypeName,
                      values.typeDescription,
                      procedureTypes.procedureType.length+1                   
                    )
                      .then(resp => {
                        //props.register(accessToken);
                       
                        disableLoading();
                        setStatus(
                          intl.formatMessage({
                            id: "CREATION.SUCCESS.MESSAGE"
                          })
                        );
                        setStatusColor('alert-success');
                        window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,

                    
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">


                  <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Procedure"
                          className="kt-width-full"
                          name="procedureTypeName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.procedureTypeName}
                          helperText={touched.procedureTypeName && errors.procedureTypeName}
                          error={Boolean(touched.procedureTypeName && errors.procedureTypeName)}
                        />
                      </div>    

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="typeDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.typeDescription}
                          helperText={touched.typeDescription && errors.typeDescription}
                          error={Boolean(touched.typeDescription && errors.typeDescription)}
                        />
                      </div> 

                      
                 
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Create Procedure
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(CreateProcedure)
);
